import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';

@Injectable()
export class PurchaseOrderService {
  private rootUrl = environment.API_URL || '';
  private shopId: string;

  constructor(private httpClient: HttpClient) {
    this.shopId = localStorage.getItem('userID') || '';
  }

  getPendingOrders(): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/po/orders`, { id: this.shopId })
      .map((res: any) => res.status ? res.data : null)
      .catch((error: any) => {
        throw error;
      });
  }

  sendPOItems(data: any): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/po/sendItems`, { ...data, id: this.shopId })
      .map((res: any) => res)
      .catch((error: any) => {
        throw error;
      });
  }

  markAsOrdered(data: any): Observable<any> {
    return this.httpClient.post(`${this.rootUrl}/po/markAsOrdered`, { ...data, id: this.shopId })
      .map((res: any) => res)
      .catch((error: any) => {
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/purchase-order.service.ts